module.exports = __webpack_public_path__ + "img/edex-icons.26e7ca4c.svg";